enum ROLE {
  ANONYMOUS = "anonymous",
  GUEST = "guest",
  ADMIN = "admin"
}

export default ROLE;
